import TabsView from '@/layouts/tabs/TabsView';
import PageView from '@/layouts/PageView';

// 路由配置
const options = {
    routes: [
        {
            path: '/login',
            name: '登录页',
            meta: {
                trackNameZh: '登录页'
            },
            component: () => import('@/pages/login')
        },
        {
            path: '/application/replenishment',
            name: '智能补货',
            meta: {
                trackNameZh: '智能补货'
            },
            component: () => import('@/pages/application/replenishment/index')
        },
        {
            path: '/smartWiring',
            name: '干线组网',
            component: () => import('@/pages/setting/index'),
            meta: {
                trackNameZh: '干线组网',
                page: {
                    cacheAble: false
                }
            }
        },
        {
            path: '/otmsSmartWiring',
            name: '干线组网',
            component: () => import('@/pages/otmsSetting/index'),
            meta: {
                trackNameZh: '干线组网',
                page: {
                    cacheAble: false
                }
            }
        },
        {
            path: '/trunkNetwork/approval',
            name: '邮件审批',
            meta: {
                trackNameZh: '邮件审批'
            },
            component: () => import('@/pages/setting/smartWiring/approval/index')
        },
        {
            path: '/application/plannedOrderManage',
            name: '管理计划单',
            meta: {
                trackNameZh: '管理计划单'
            },
            component: () => import('@/pages/setting/plannedOrderManage/index')
        },
        {
            path: '*',
            name: '404',
            component: () => import('@/pages/exception/404')
        },
        {
            path: '/403',
            name: '403',
            component: () => import('@/pages/exception/403')
        },
        {
            path: '/enterprise/authentication',
            name: '企业认证',
            meta: {
                trackNameZh: '企业认证'
            },
            component: () => import('@/pages/enterprise/authentication')
        },
        {
            path: '/enterprise/successAuth',
            name: '认证成功',
            meta: {
                trackNameZh: '认证成功'
            },
            component: () => import('@/pages/enterprise/successAuth')
        },
        {
            path: '/seekWarehouses',
            name: '我要寻仓',
            component: () => import('@/pages/seekWarehouse/seekWarehouse'),
            children: [
                {
                    path: '/detail',
                    name: '寻仓详情',
                    meta: {
                        invisible: true,
                        trackNameZh: '寻仓详情(未登录)'
                    },
                    component: () => import('@/pages/seekWarehouse/detail')
                },
                {
                    path: '/seekWarehouses',
                    name: '我要寻仓',
                    meta: {
                        invisible: true,
                        trackNameZh: '我要寻仓(未登录)'
                    },
                    component: () => import('@/pages/seekWarehouse/index')
                }
            ]
        },
        {
            path: '/',
            name: '首页',
            component: TabsView,
            // redirect: '/data/overview',
            children: [
                {
                    path: '/modifyPassword',
                    name: '修改密码',
                    meta: {
                        invisible: true,
                        trackNameZh: '修改密码'
                    },
                    component: () => import('@/pages/login/ModifyPassword')
                },
                {
                    path: '/order',
                    name: '订单',
                    meta: {
                        icon: 'file-text'
                    },
                    component: PageView,
                    children: [
                        {
                            path: 'createOrder',
                            name: '选择下单产品',
                            meta: {
                                invisible: true,
                                trackNameZh: '选择下单产品',
                                page: {
                                    cacheAble: false
                                }
                            },
                            component: () => import('@/pages/orderManage/CreateOrder')
                        },
                        {
                            path: 'editOrder',
                            name: '编辑',
                            meta: {
                                invisible: false,
                                trackNameZh: '纯运输订单编辑'
                            },
                            component: () => import('@/pages/orderManage/CreateOrder')
                        },
                        {
                            path: 'manage',
                            name: '纯运输订单',
                            component: () => import('@/pages/orderManage/orderManageList'),
                            meta: {
                                trackNameZh: '纯运输订单',
                                page: {
                                    cacheAble: true
                                }
                            }
                        },
                        {
                            path: 'create-single',
                            name: '下单',
                            meta: {
                                invisible: true,
                                trackNameZh: '纯运输订单下单',
                                page: {
                                    cacheAble: false
                                }
                            },
                            component: () => import('@/pages/orderManage/OrderManageCreate/index.vue')
                        },
                        {
                            path: 'edit',
                            name: '编辑订单',
                            meta: {
                                invisible: true,
                                trackNameZh: '纯运输订单编辑',
                                page: {
                                    cacheAble: false
                                },
                                canRefresh: false
                            },
                            component: () => import('@/pages/orderManage/OrderManageCreate/index.vue')
                        },
                        {
                            // 标准产品下单
                            path: 'standard-create-single',
                            name: '下单',
                            meta: {
                                invisible: true,
                                trackNameZh: '标准产品下单',
                                page: {
                                    cacheAble: false
                                }
                            },
                            component: () => import('@/pages/orderManage/StandardOrderManageCreate/index.vue')
                        },
                        {
                            //  标准产品编辑
                            path: 'standard-edit',
                            name: '编辑订单',
                            meta: {
                                invisible: true,
                                trackNameZh: '标准产品编辑',
                                page: {
                                    cacheAble: false
                                },
                                canRefresh: false
                            },
                            component: () => import('@/pages/orderManage/StandardOrderManageCreate/index.vue')
                        },
                        {
                            path: 'create-multiple',
                            name: '批量导入下单',
                            meta: {
                                invisible: true,
                                trackNameZh: '批量导入下单',
                                page: {
                                    cacheAble: false
                                }
                            },
                            component: () => import('@/pages/orderManage/OrderManageCreateMultiple')
                        },
                        {
                            path: 'detail',
                            name: '订单详情',
                            meta: {
                                invisible: true,
                                trackNameZh: '纯运输订单详情',
                                page: {
                                    cacheAble: false
                                }
                            },
                            component: () => import('@/pages/orderManage/orderManageDetail')
                        },
                        {
                            path: 'warehouseList',
                            name: '仓配订单',
                            component: () => import('@/pages/warehouseOrder/warehouseList/WarehouseList.vue'),
                            meta: {
                                trackNameZh: '仓配订单',
                                page: {
                                    cacheAble: true
                                }
                            }
                        },
                        {
                            path: 'warehous-create-single',
                            name: '下单',
                            meta: {
                                invisible: true,
                                trackNameZh: '仓配订单下单',
                                page: {
                                    cacheAble: false
                                }
                            },
                            component: () => import('@/pages/warehouseOrder/warehouseCreate/WarehouseCreate.vue')
                        },
                        {
                            path: 'warehous-edit-single',
                            name: '编辑',
                            meta: {
                                invisible: true,
                                trackNameZh: '仓配订单编辑',
                                page: {
                                    cacheAble: false
                                }
                            },
                            component: () => import('@/pages/warehouseOrder/warehouseCreate/WarehouseCreate.vue')
                        },
                        {
                            path: 'warehous-detail',
                            name: '订单详情',
                            meta: {
                                trackNameZh: '仓配订单详情',
                                invisible: true,
                                page: {
                                    cacheAble: false
                                }
                            },
                            component: () => import('@/pages/warehouseOrder/warehouseDetail/WarehouseDetail.vue')
                        },
                        {
                            path: 'warehousePlanOrder',
                            name: '仓配计划单',
                            meta: {
                                trackNameZh: '仓配计划单',
                                page: {
                                    cacheAble: true
                                }
                            },
                            component: () => import('@/pages/warehousePlanOrder/index')
                        },
                        {
                            path: 'inventoryOrder',
                            name: '盘点单',
                            meta: {
                                trackNameZh: '盘点单',
                                page: {
                                    cacheAble: true
                                }
                            },
                            component: () => import('@/pages/newVersionPage/index.vue')
                        }
                    ]
                },
                {
                    path: '/seekWarehouse',
                    name: '我要寻仓',
                    meta: {
                        icon: 'file-text',
                        trackNameZh: '我要寻仓',
                        page: {
                            cacheAble: true
                        }
                    },
                    component: () => import('@/pages/seekWarehouse/index')
                },
                {
                    path: '/seekWarehouse/detail',
                    name: '寻仓详情',
                    meta: {
                        icon: 'file-text',
                        trackNameZh: '寻仓详情',
                        page: {
                            cacheAble: false
                        }
                    },
                    component: () => import('@/pages/seekWarehouse/detail')
                },
                {
                    path: '/data',
                    name: '数据分析',
                    meta: {
                        icon: 'file-text',
                        page: {
                            cacheAble: true
                        }
                    },
                    component: PageView,
                    children: [
                        {
                            path: '/data/overview',
                            name: '数据概览',
                            component: () => import('@/pages/data/overview'),
                            meta: {
                                trackNameZh: '数据概览',
                                page: {
                                    cacheAble: false
                                }
                            }
                        },
                        {
                            path: '/data/goodsPlate',
                            name: '货品板位信息',
                            component: () => import('@/pages/data/goodsPlate'),
                            meta: {
                                trackNameZh: '货品板位信息',
                                page: {
                                    cacheAble: false
                                }
                            }
                        },
                        {
                            path: 'stock',
                            name: '库存及明细管理',
                            meta: {
                                icon: 'file-text',
                                page: {
                                    cacheAble: false
                                }
                            },
                            component: PageView,
                            children: [
                                {
                                    path: '/data/inventory',
                                    name: '在库库存查询',
                                    component: () => import('@/pages/data/InventoryManage'),
                                    meta: {
                                        trackNameZh: '在库库存查询',
                                        page: {
                                            cacheAble: false
                                        }
                                    }
                                },
                                {
                                    path: '/data/deliveryDetails',
                                    name: '出库明细',
                                    component: () => import('@/pages/data/deliveryDetails'),
                                    meta: {
                                        trackNameZh: '出库明细',
                                        page: {
                                            cacheAble: false
                                        }
                                    }
                                },
                                {
                                    path: '/data/warehousingDetail',
                                    name: '入库明细',
                                    component: () => import('@/pages/data/deliveryDetails'),
                                    meta: {
                                        trackNameZh: '入库明细',
                                        page: {
                                            cacheAble: false
                                        }
                                    }
                                },
                                {
                                    path: '/data/historyInventory',
                                    name: '历史库存查询',
                                    component: () => import('@/pages/data/deliveryDetails'),
                                    meta: {
                                        trackNameZh: '历史库存查询',
                                        page: {
                                            cacheAble: false
                                        }
                                    }
                                }
                            ]
                        },
                        {
                            path: '/data/purchaseSaleStock',
                            name: '进销存报表',
                            component: () => import('@/pages/data/purchaseSaleStock'),
                            meta: {
                                trackNameZh: '进销存报表',
                                page: {
                                    cacheAble: false
                                }
                            }
                        },
                        {
                            path: 'onLineBill',
                            name: '在线账单',
                            component: () => import('@/pages/data/onLineBill/index.vue'),
                            meta: {
                                trackNameZh: '在线账单',
                                page: {
                                    cacheAble: true
                                }
                            }
                        },
                        {
                            path: '/data/goodsTracking',
                            name: '货品全链路追踪',
                            component: () => import('@/pages/data/goodsTracking'),
                            meta: {
                                trackNameZh: '货品全链路追踪',
                                page: {
                                    cacheAble: false
                                }
                            }
                        },
                        {
                            path: '/data/onLineBill/billDetails',
                            name: '账单详情',
                            component: () => import('@/pages/data/onLineBill/components/billDetails'),
                            meta: {
                                trackNameZh: '账单详情',
                                page: {
                                    cacheAble: false
                                }
                            }
                        },
                        {
                            path: '/data/priceEexception',
                            name: '计费异常',
                            meta: {
                                trackNameZh: '数据概览-计费异常',
                                invisible: true,
                                page: {
                                    cacheAble: false
                                }
                            },
                            component: () => import('@/pages/data/order')
                        },
                        {
                            path: '/data/outboundexception',
                            name: '出库异常',
                            meta: {
                                trackNameZh: '数据概览-出库异常',
                                invisible: true,
                                page: {
                                    cacheAble: false
                                }
                            },
                            component: () => import('@/pages/data/order')
                        },
                        {
                            path: '/data/dispatchTimeout',
                            name: '派车超时',
                            meta: {
                                trackNameZh: '数据概览-派车超时',
                                invisible: true,
                                page: {
                                    cacheAble: false
                                }
                            },
                            component: () => import('@/pages/data/order')
                        },
                        {
                            path: '/data/pickTimeout',
                            name: '取货超时',
                            meta: {
                                trackNameZh: '数据概览-取货超时',
                                invisible: true,
                                page: {
                                    cacheAble: false
                                }
                            },
                            component: () => import('@/pages/data/order')
                        },
                        {
                            path: '/data/signTtimeout',
                            name: '签收超时',
                            meta: {
                                trackNameZh: '数据概览-签收超时',
                                invisible: true,
                                page: {
                                    cacheAble: false
                                }
                            },
                            component: () => import('@/pages/data/order')
                        },
                        {
                            path: '/data/temperatureEexception',
                            name: '温度异常',
                            meta: {
                                invisible: true,
                                trackNameZh: '数据概览-温度异常',
                                page: {
                                    cacheAble: false
                                }
                            },
                            component: () => import('@/pages/data/order')
                        },
                        {
                            path: '/data/cargoWarning',
                            name: '轨迹预警',
                            meta: {
                                invisible: true,
                                trackNameZh: '数据概览-轨迹预警',
                                page: {
                                    cacheAble: false
                                }
                            },
                            component: () => import('@/pages/data/order')
                        }
                    ]
                },
                {
                    path: '/application',
                    name: '我的应用',
                    meta: {
                        trackNameZh: '我的应用'
                    },
                    component: () => import('@/pages/application/index')
                },
                {
                    path: '/replenishment',
                    name: '智能补货',
                    meta: {
                        trackNameZh: '我的应用',
                        page: {
                            cacheAble: false
                        }
                    },
                    component: () => import('@/pages/application/replenishment/index')
                },
                {
                    path: '/application/antiCrosstalk',
                    name: '防窜货',
                    meta: {
                        trackNameZh: '防窜货'
                    },
                    component: () => import('@/pages/application/iframe/index')
                },
                {
                    path: '/application/aiWarning',
                    name: 'AI预警',
                    meta: {
                        trackNameZh: 'AI预警'
                    },
                    component: () => import('@/pages/application/iframe/index')
                },
                {
                    path: '/application/dispatch',
                    name: '调度大师',
                    meta: {
                        trackNameZh: '调度大师'
                    },
                    component: () => import('@/pages/application/iframe/index')
                },
                {
                    path: '/application/sign',
                    name: '电子回单',
                    meta: {
                        trackNameZh: '电子回单'
                    },
                    component: () => import('@/pages/application/iframe/index')
                },
                {
                    path: '/application/panoramicMap',
                    name: '全景图谱',
                    meta: {
                        trackNameZh: '全景图谱'
                    },
                    component: () => import('@/pages/application/iframe/index')
                },
                {
                    path: '/application/intelligentCable',
                    name: '智能排线',
                    meta: {
                        trackNameZh: '智能排线'
                    },
                    component: () => import('@/pages/application/iframe/index')
                },
                {
                    path: '/application/businessInquiry',
                    name: '智能报价',
                    meta: {
                        trackNameZh: '智能报价'
                    },
                    component: () => import('@/pages/application/iframe/index')
                },
                {
                    path: '/application/intelligentBI',
                    name: '智能BI',
                    meta: {
                        trackNameZh: '智能BI'
                    },
                    component: () => import('@/pages/application/iframe/index')
                },
                {
                    path: '/setting',
                    name: '设置',
                    meta: {
                        icon: 'setting',
                        page: {
                            cacheAble: false
                        }
                    },
                    component: PageView,
                    children: [
                        {
                            path: '/profile',
                            name: '基础信息',
                            component: () => import('@/pages/login/Profile'),
                            meta: {
                                trackNameZh: '基础信息',
                                page: {
                                    cacheAble: false
                                }
                            }
                        },
                        {
                            path: '/organization',
                            name: '组织及项目',
                            component: () => import('@/pages/organization/Organization'),
                            meta: {
                                trackNameZh: '组织及项目',
                                page: {
                                    cacheAble: false
                                }
                            }
                        },
                        {
                            path: '/account',
                            name: '账号管理',
                            component: () => import('@/pages/account/Account'),
                            meta: {
                                trackNameZh: '账号管理',
                                page: {
                                    cacheAble: false
                                }
                            }
                        },
                        {
                            path: '/addaccount',
                            name: '新建账号',
                            meta: {
                                trackNameZh: '新建账号',
                                invisible: true,
                                page: {
                                    cacheAble: false
                                }
                            },
                            component: () => import('@/pages/account/AddAccount')
                        },
                        {
                            path: '/addaccountEdit',
                            name: '编辑账号',
                            meta: {
                                trackNameZh: '编辑账号',
                                invisible: true,
                                page: {
                                    cacheAble: false
                                }
                            },
                            component: () => import('@/pages/account/AddAccount')
                        },
                        {
                            path: '/authentication',
                            name: '实名认证',
                            meta: {
                                trackNameZh: '实名认证',
                                invisible: true,
                                page: {
                                    cacheAble: false
                                }
                            },
                            component: () => import('@/pages/enterprise/authentication')
                        },
                        {
                            path: '/siteManagement',
                            name: '站点管理',
                            component: () => import('@/pages/setting/siteMmanagement/list'),
                            meta: {
                                trackNameZh: '站点管理',
                                page: {
                                    cacheAble: false
                                }
                            }
                        },
                        {
                            path: '/customImport',
                            name: '自定义导入模板',
                            component: () => import('@/pages/newVersionPage/index.vue'),
                            meta: {
                                trackNameZh: '自定义导入模板',
                                page: {
                                    cacheAble: false
                                }
                            }
                        },
                        {
                            path: '/addCustomImport',
                            name: '新建导入模板',
                            component: () => import('@/pages/setting/customImport/edit'),
                            meta: {
                                trackNameZh: '新建导入模板',
                                invisible: true,
                                page: {
                                    cacheAble: false
                                }
                            }
                        },
                        {
                            path: '/editCustomImport',
                            name: '修改导入模板',
                            component: () => import('@/pages/setting/customImport/edit'),
                            meta: {
                                invisible: true,
                                trackNameZh: '修改导入模板',
                                page: {
                                    cacheAble: false
                                }
                            }
                        },
                        {
                            path: '/productManagement',
                            name: '货品管理',
                            component: () => import('@/pages/newVersionPage/index.vue'),
                            meta: {
                                title: '货品管理'
                            }
                        },
                        {
                            path: '/createTemplate',
                            name: '创建自定义模板',
                            component: () => import('@/pages/newVersionPage/index.vue'),
                            meta: {
                                title: '创建自定义模板'
                            }
                        },
                        {
                            path: '/editTemplate',
                            name: '编辑自定义模板',
                            component: () => import('@/pages/newVersionPage/index.vue'),
                            meta: {
                                title: '编辑自定义模板'
                            }
                        },
                        {
                            path: 'orderConfig',
                            name: '下单配置',
                            component: () => import('@/pages/newVersionPage/index.vue'),
                            meta: {
                                title: '下单配置'
                            }
                        }
                    ]
                },
                {
                    path: '/task',
                    name: '任务',
                    meta: {
                        invisible: true,
                        trackNameZh: '任务',
                        page: {
                            cacheAble: false
                        }
                    },
                    component: () => import('@/pages/task/TaskList')
                },
                {
                    path: '/modifyAccount',
                    name: '修改账号',
                    meta: {
                        trackNameZh: '修改账号',
                        invisible: true,
                        page: {
                            cacheAble: false
                        }
                    },
                    component: () => import('@/pages/account/ModifyAccount')
                },
                {
                    path: '/inTransitGoods',
                    name: '在途货品-在途监控',
                    meta: {
                        trackNameZh: '在途货品-在途监控',
                        invisible: true,
                        page: {
                            cacheAble: false
                        }
                    },
                    component: () => import('@/pages/orderManage/orderManageDetail/components/iframeView.vue')
                }
            ]
        },
        {
            path: '/forgot-password',
            name: '忘记密码',
            meta: {
                trackNameZh: '修改账号'
            },
            component: () => import('@/pages/login/ForgotPassword')
        },
        {
            path: '/wxscancode',
            name: '扫码登录',
            component: () => import('@/pages/wxscancode')
        }

        // {
        //     path: 'create-multiple',
        //     name: '批量导入下单',
        //     meta: {
        //         invisible: true,
        //         trackNameZh: '批量导入下单',
        //         page: {
        //             cacheAble: false
        //         }
        //     },
        //     component: () => import('@/pages/orderManage/OrderManageCreateMultiple')
        // },
        // {
        //     path: '/taskList',
        //     name: '任务',
        //     meta: {
        //         invisible: true,
        //         trackNameZh: '任务',
        //         page: {
        //             cacheAble: false
        //         }
        //     },
        //     component: () => import('@/pages/task/TaskList')
        // },
    ]
};

export default options;
